import { CalendarType } from '../models/calendar'

interface QuickTipConfig {
  translationKey: string
  includeCalendarType?: CalendarType[]
  excludeCalendarType?: CalendarType[]
}

const quickTips: Record<string, QuickTipConfig[]> = {
  'meeting-details': [
    {
      translationKey:
        'quick_tips.meeting_details.include_contact_and_user_names',
    },
    {
      translationKey: 'quick_tips.meeting_details.add_backup_meeting_url',
    },
    {
      translationKey: 'quick_tips.meeting_details.enable_gmeet_primary',
      includeCalendarType: [CalendarType.ROUND_ROBIN],
    },
  ],
  availability: [
    {
      translationKey: 'quick_tips.availability.twenty_four_hours',
      excludeCalendarType: [CalendarType.SERVICE],
    },
    {
      translationKey: 'quick_tips.availability.update_timezone_preferences',
      excludeCalendarType: [CalendarType.SERVICE],
    },
    {
      translationKey: 'quick_tips.availability.service_calendar_slot_interval',
      includeCalendarType: [CalendarType.SERVICE],
    },
  ],
  forms: [
    {
      translationKey: 'quick_tips.forms.create_custom_forms',
    },
    {
      translationKey: 'quick_tips.forms.apply_sticky_contacts',
    },
    {
      translationKey: 'quick_tips.forms.use_custom_values',
    },
  ],
  notifications: [
    {
      translationKey: 'quick_tips.notifications.use_workflows',
    },
  ],
  customizations: [
    {
      translationKey: 'quick_tips.customizations.update_widget_language',
    },
  ],
  equipments: [
    {
      translationKey: 'quick_tips.equipments.room_definition',
    },
    {
      translationKey: 'quick_tips.equipments.equipment_definition',
    },
  ],
}

export const getQuickTip = (
  key: string,
  calendarType: CalendarType | undefined,
  t: (translationKey: string) => string
) => {
  const quickTipConfigs = quickTips[key] ?? quickTips['meeting-details']

  const availableTips = quickTipConfigs.filter(tip => {
    if (tip.includeCalendarType) {
      if (calendarType && tip.includeCalendarType.includes(calendarType)) {
        return true
      }
      return false
    }
    if (tip.excludeCalendarType) {
      if (!calendarType || !tip.excludeCalendarType.includes(calendarType)) {
        return true
      }
      return false
    }
    return true
  })

  const quickTipsLength = availableTips.length
  if (!quickTipsLength) {
    return ''
  }

  const randomIndex = Math.floor(Math.random() * quickTipsLength)
  const selectedTip = availableTips[randomIndex]

  return selectedTip ? t(selectedTip.translationKey) : ''
}
